import {defineStore} from 'pinia'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    login: false,
    userInfo: {}
  }),
  getters: {
    getUserInfo: state => state.userInfo,
    isLogin: state => state.login,
    isUserType: state => state.userInfo.type
  },
  actions: {
    setLogin() {
      this.login = true
    },
    setUserSource(source) {
      this.userInfo.source = source
    },
    setUserInfo(userInfo) {
      this.userInfo = {...this.userInfo, ...userInfo}
    },
    resetVariables() {
      this.userInfo = {}
      this.login = false
    }
  },
  persist: {
    storage: persistedState.sessionStorage
  }
})
